import createAPI from '../axios'
//基础信息相关API

const qualificationRateStatistics = {
    qualificationRateStatistics: {
        initCombo: config => createAPI('/qualificationRateStatisticsSkillsTraining/qualificationRateStatistics/initCombo', 'post', config),
        queryList: config => createAPI('/qualificationRateStatisticsSkillsTraining/qualificationRateStatistics/queryList', 'post', config),
    }
};

export default qualificationRateStatistics;



// WEBPACK FOOTER //
// ./src/api/modules/qualificationRateStatisticsSkillsTraining.js